import ApiSdk from 'services/callApi'
import {Notification} from '@binance/uikit'
import {formatDate} from 'utils/format'

export default function useTransferAsset (i18n, lng, ...props) {
  ApiSdk.futures
  .transferAsset(...props, {
    lang: lng
  })
  .then(res => {
    if (res?.error || res === undefined) {
      Notification({
        content: res?.error || i18n.failureTransferAsset,
        type: 'error',
        duration: 3000
        // time: formatDate(new Date(), 'HH:mm:ss')
      })
    } else {
      Notification({
        content: `${props[1]} ${i18n.successTransferAsset}`,
        type: 'success',
        duration: 3000
        // time: formatDate(new Date(), 'HH:mm:ss')
      })
    }
  })
  .catch(() => {
    Notification({
      content: i18n.failureTransferAsset,
      type: 'error',
      duration: 3000
      // time: formatDate(new Date(), 'HH:mm:ss')
    })
  })
}
